import { TopbarFeature } from './TopbarFeature';

export type TopbarJson = {
    [key: string]: boolean;
};

export const AllTopbarFeatures = {
    messages: new TopbarFeature({
        key: 'messages',
        icon: 'chat',
        title: 'Meddelanden',
        action: 'messagesAction',
        pinned: false,
        requiredConfig: 'messages.topbar.button',
        badge: {
            enabled: true,
            source: null, // This will be set later in the service
        },
    }),
    systemnotices: new TopbarFeature({
        key: 'systemnotices',
        icon: 'update',
        title: 'Systemuppdateringar',
        action: 'systemnoticesAction',
        pinned: true,
        requiredConfig: 'unitConfig.panel.systemnotices.enabled',
        badge: {
            enabled: true,
            source: null, // This will be set later in the service
        },
    }),
    help: new TopbarFeature({
        key: 'help',
        icon: 'help_outline',
        title: 'Hjälp',
        action: 'helpAction',
        pinned: true,
        requiredConfig: 'help.enabled',
    }),
    medialibrary: new TopbarFeature({
        key: 'medialibrary',
        icon: 'perm_media',
        title: 'Mediebibliotek',
        action: 'medialibraryAction',
        pinned: true,
        requiredPermissions: 'filesystem.read',
        reverseRequiredConfig: 'hideMediaInTopBar',
    }),
};
